//function CheckModified (Element)
//{
//	var OldValue = Element.getAttribute ('OldValue');
//	var NewValue = Element.value;
//	
//	if (OldValue == NewValue)
//		removeClass (Element, 'Modified');
//	else
//		addClass (Element, 'Modified');
//
//	SlideMacros();
//}

function SlideMacros()
{
	var description = document.getElementById('SsActionDescription');

	if (description.attributes.name != 'Set')
	{
		var siteFieldNames = getElementsByClass('cSsFieldConfigTable');
		var selectedOptionNumber = siteFieldNames[0].nextSibling.nextSibling.selectedIndex;
		var test = siteFieldNames[0].nextSibling.nextSibling.options[selectedOptionNumber].text;

		var suggestedDescription = '';
		for ( var i = 0; i < siteFieldNames.length; i++)
		{
			var selectField = siteFieldNames[i].nextSibling.nextSibling;
			var selectedOptionNumber = selectField.selectedIndex;
			var selectedText = selectField[selectedOptionNumber].text;
			if (selectedText.length > 0){suggestedDescription = suggestedDescription + selectedText + ' ';}
		}

		description.value = ' ' + suggestedDescription;
		description.className = 'Modified';
	}
}